<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  deal: {
    type: Object,
    default: () => ({}),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['confirm']);

const { t } = useI18n();

const dialogRef = ref(null);

const description = computed(() =>
  props.deal?.name
    ? t('DEALS.LIST.DELETE.DESCRIPTION_WITH_NAME', {
        dealName: props.deal.name,
      })
    : t('DEALS.LIST.DELETE.DESCRIPTION')
);

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('DEALS.LIST.DELETE.TITLE')"
    :description="description"
    :confirm-button-label="t('DEALS.LIST.DELETE.CONFIRM')"
    :is-loading="isLoading"
    @confirm="emit('confirm')"
  />
</template>
